import React, { useCallback, Fragment } from 'react';
import Gauge from 'components/pages/livefeed/Editor/EditorContainer/common/Gauge'
import ReactTooltip from "react-tooltip";
import { Rnd } from 'react-rnd';
import { RndStyle } from '../RndStyle'
import { getPosition, handleSetCurrentEntity } from 'components/pages/livefeed/Editor/EditorContainer/common/commonFn'
import './index.less'
import update from 'immutability-helper';
import { updateGauge } from 'actions/livefeed'
import Modal from "components/common/modal"

const GaugeCard = (props) => {
    React.useEffect(() => {
        ReactTooltip.rebuild()// componentDidUpdate()
    })
    const { dispatch, livefeedSlides, editorView, slideCurrentIndex, stepNumberState } = props

    const { floorplanOptions: { widgetLabelType }, historyEntities, rightPanelGaugeOffsetdBg, rightPanelGaugeOccupiedBg, rightPanelGaugeNeedle, rightPanelTextTitle, rightPanelGaugeValueLabel } = livefeedSlides[slideCurrentIndex]
    let history = historyEntities.slice();
    let currentEntity = history[stepNumberState];
    const { scaleMode, values, colorPickerRef, title, gauge } = props

    const setCurrentEntitySwitch = useCallback((e, entity) => {
        e.preventDefault();
        e.stopPropagation();
        handleSetCurrentEntity(currentEntity, entity, dispatch)
    }, [currentEntity, dispatch])

    const setGaugePos = useCallback((newPosition) => {
        let { x, y } = newPosition;
        // prevent duplicate dispatch
        if (gauge.left !== x || gauge.top !== y) {
            const newGaugePos = update(gauge, {
                top: { $set: y },
                left: { $set: x },
                align: { $set: "" },
                activeToolbarItems: { [0]: { align: { $set: "" } } }
            });
            dispatch(updateGauge(newGaugePos));
        }
    }, [dispatch, gauge])

    const setGaugeSize = useCallback((width, newPosition) => {
        let newWidth = width > 534 ? 534 : width; // maximum width 534
        let { x, y } = newPosition
        let align = `${gauge.left === x ? `${gauge.activeToolbarItems[0].align}` : ""}` // if x doesn't change, keep toolbar active
        if (gauge.width !== width || gauge.left !== newPosition.x) {
            const newGaugeSize = update(gauge, {
                top: { $set: y },
                left: { $set: x },
                align: { $set: align },
                width: { $set: newWidth },
                activeToolbarItems: {
                    [0]: {
                        align: { $set: align }
                    }
                }
            });
            dispatch(updateGauge(newGaugeSize));
        }
    }, [dispatch, gauge])


    let gaugeValueLabelAlign;
    switch (rightPanelGaugeValueLabel.align) {
        case "left":
            gaugeValueLabelAlign = "flex-start";
            break;
        case "right":
            gaugeValueLabelAlign = "flex-end";
            break;
        case "center":
            gaugeValueLabelAlign = "center"
            break;
    }
    const enableResizing = {
        bottom: false, bottomLeft: editorView, bottomRight: editorView,
        left: false, right: false, top: false,
        topLeft: editorView, topRight: editorView
    }
    const handleSetCurrentEntityCallback = useCallback(() => {
        handleSetCurrentEntity(currentEntity, gauge, dispatch)
    }, [currentEntity, dispatch, gauge])


    const gaugeTitleModalRef = React.useRef(null);
    const [gaugeTitleState, setGaugeTitleState] = React.useState('')
    const [isEditMode, setEditMode] = React.useState(false)

    const inputOnchange = useCallback((e) => {
        if (isEditMode) {
            setGaugeTitleState(e.target.value)
        }
    }, [isEditMode])

    function inputDoubleClick(e) {
        e.preventDefault();
        e.stopPropagation();
        setEditMode(true)
        gaugeTitleModalRef.current.open()
    }


    React.useEffect(() => {
        setGaugeTitleState(title)
    }, [title, rightPanelTextTitle.contents])

    const confirmEditTitle = useCallback((e) => {
        e.preventDefault()
        e.stopPropagation()
        const newTitle = update(gauge, {
            label: { $set: gaugeTitleState }
        });
        dispatch(updateGauge(newTitle));
        gaugeTitleModalRef.current.close()
    }, [dispatch, gauge, gaugeTitleState])

    const titleTip = `Click and choose toolbar options to change text style <br /> Double click to edit text`;

    function renderGaugeCards() {
        return (
            <Fragment>
                <div className="card-container" >
                    <div className={`card-svg`}
                        style={{ justifyContent: gaugeValueLabelAlign, userSelect: 'none' }} >
                        {/* click able svg areas */}
                        <div style={{ borderColor: `${editorView ? `${rightPanelTextTitle.color}` : 'none'}` }}
                            className={`card-svg__editor ${editorView ? '' : 'card-svg__preview'}`} >
                            {editorView &&
                                <React.Fragment>
                                    <div className={`rect rect_occupied ${currentEntity.id === "rightPanelGaugeOccupiedBg" ? 'rect_occupied_active' : ''}`}
                                        data-tip="Click to change gauge's occupied color"
                                        onClick={(e) => {
                                            setCurrentEntitySwitch(e, rightPanelGaugeOccupiedBg)
                                            colorPickerRef.current.openColorPicker()
                                        }}
                                    />
                                    <div className={`rect ${currentEntity.id === "rightPanelGaugeOffsetdBg" ? 'rect_active' : ''}`}
                                        data-tip="Click to change gauge's offset color"
                                        onClick={(e) => {
                                            setCurrentEntitySwitch(e, rightPanelGaugeOffsetdBg)
                                            colorPickerRef.current.openColorPicker()
                                        }}
                                    />
                                    <div className={`needle ${currentEntity.id === "rightPanelGaugeNeedle" ? 'needle_active' : ''}`}
                                        data-tip="Click to change the needle's color"
                                        onClick={(e) => {
                                            setCurrentEntitySwitch(e, rightPanelGaugeNeedle)
                                            colorPickerRef.current.openColorPicker()
                                        }}
                                    />
                                </React.Fragment>
                            }
                        </div>

                        <Gauge
                            values={values}
                            rightPanelGaugeOffsetdBg={rightPanelGaugeOffsetdBg}
                            rightPanelGaugeOccupiedBg={rightPanelGaugeOccupiedBg}
                            rightPanelGaugeNeedle={rightPanelGaugeNeedle}
                            widgetLabelType={widgetLabelType}
                            currentEntity={currentEntity}
                            widgetStyle={{
                                borderColor: `${editorView ? `${rightPanelGaugeValueLabel.color}` : 'transparent'}`,
                                color: rightPanelGaugeValueLabel.color,
                                fontSize: rightPanelGaugeValueLabel.size * (props.scaleMode ? 0.375 : 1),
                                fontWeight: rightPanelGaugeValueLabel.textStyle.bold ? 'bold' : 'unset',
                                fontStyle: rightPanelGaugeValueLabel.textStyle.italic ? 'italic' : 'unset',
                                textDecoration: rightPanelGaugeValueLabel.textStyle.underline ? 'underline' : 'unset'
                            }}
                            setCurrentEntitySwitch={(e) => setCurrentEntitySwitch(e, rightPanelGaugeValueLabel)}
                        />
                    </div>
                    <div className="card-bottom" style={{ textAlign: rightPanelTextTitle.align }}>
                        <div
                            data-tip={titleTip}
                            className={`card-title`}
                            onClick={(e) => setCurrentEntitySwitch(e, rightPanelTextTitle)}
                            onDoubleClick={(e) => inputDoubleClick(e)}
                            style={{
                                zIndex: 3,
                                color: rightPanelTextTitle.color,
                                fontSize: rightPanelTextTitle.size * (props.scaleMode ? 0.375 : 1),
                                fontWeight: rightPanelTextTitle.textStyle.bold ? 'bold' : 'unset',
                                fontStyle: rightPanelTextTitle.textStyle.italic ? 'italic' : 'unset',
                                textDecoration: rightPanelTextTitle.textStyle.underline ? 'underline' : 'unset'
                            }}>
                            {title}
                            <span className={`${editorView ? 'card-title__editor-border' : 'card-title__preview'} ${currentEntity.id === "rightPanelTextTitle" ? 'card-title__editor-border_active' : ''}`} />
                        </div>
                    </div>
                </div>

            </Fragment >
        )
    }
    return (
        <React.Fragment>
            {editorView ?

                <Rnd
                    bounds={".livefeed-preview-wrapper"}
                    enableResizing={enableResizing}
                    disableDragging={!editorView}
                    style={{
                        pointerEvents: editorView ? 'all' : 'none',
                        border: !editorView && 'none'
                    }}
                    className={`entity-resizable  ${currentEntity.id === 'gauge' ? 'entity-active' : ''} `}
                    lockAspectRatio={true}
                    resizeHandleWrapperClass={"resizers"}
                    resizeHandleStyles={{
                        topRight: RndStyle.topRight, topLeft: RndStyle.topLeft,
                        bottomLeft: RndStyle.bottomLeft, bottomRight: RndStyle.bottomRight
                    }}
                    size={{ width: gauge.width * (scaleMode ? 0.375 : 1) + 12, height: "auto" }}
                    position={{ x: gauge.left * (scaleMode ? 0.375 : 1) - 6, y: gauge.top * (scaleMode ? 0.375 : 1) - 6 }}
                    onClick={() => handleSetCurrentEntityCallback()}
                    onDragStart={() => handleSetCurrentEntityCallback()}
                    onDragStop={(e, d) => setGaugePos(getPosition(d))}
                    onResizeStart={() => handleSetCurrentEntityCallback()}
                    onResizeStop={(e, direction, ref, delta, position) =>
                        position.x !== 0 && setGaugeSize(ref.offsetWidth - 12, getPosition(position))}
                >
                    {renderGaugeCards()}
                </Rnd>
                :
                <div
                    style={{
                        position: "absolute",
                        width: gauge.width * (scaleMode ? 0.375 : 1) + 12,
                        height: "auto",
                        pointerEvents: "none",
                        transform: `translate(${gauge.left * (scaleMode ? 0.375 : 1) - 6}px, ${gauge.top * (scaleMode ? 0.375 : 1) - 6}px)`
                    }}
                    className={`entity-resizable editor-view_false`}
                >
                    {renderGaugeCards()}
                </div>
            }
            <ReactTooltip multiline={true} place="top" type="dark" effect="solid" />

            <Modal
                ref={gaugeTitleModalRef}
                onClose={() => setGaugeTitleState(title)}
                clickButton={(e) => confirmEditTitle(e)}
                header="Edit gauge chart title"
                buttonText="Confirm"
                buttonClass="btn-success"
                entry={null}
            >
                <input
                    value={gaugeTitleState}
                    name={gaugeTitleState}
                    onChange={(e) => inputOnchange(e)} type="text" />
            </Modal>
        </React.Fragment>
    );
}


export default GaugeCard


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/LivefeedPreview/LeftPaneView/entity/GaugeCard/index.jsx